type Deletable = { deleted_at: number | null };

// 単一引数：型ガード
export function IsAnyDeleted<T extends Deletable>(v: T | null | undefined): v is null | undefined | (T & { deleted_at: number });

// 複数引数：boolean（型は縛らない）
export function IsAnyDeleted(...values: Array<Deletable | null | undefined>): boolean;

// 実装
export function IsAnyDeleted(...values: Array<Deletable | null | undefined>): boolean {
  return values.some(v => !v || v.deleted_at !== null);
}
